export const API_TYPES = {
  WSN: "wsn",
};

export const API_APP_NAMES = {
  WSN: "express_wsn",
};
